// User reducer types
export const SET_AUTHENTICATED = "SET_AUTHENTICATED";
export const SET_UNAUTHENTICATED = "SET_UNAUTHENTICATED";
export const SET_USER = "SET_USER";
export const PATCH_PASSWORD = "PATCH_PASSWORD";
// Error reducer types
export const SET_ERROR = "SET_ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const CLEAR_ALL_ERRORS = "CLEAR_ALL_ERRORS";
// Loading reducer types
export const SET_LOADING_ACTION = "SET_LOADING_ACTION";
export const STOP_LOADING_ACTION = "STOP_LOADING_ACTION";
export const LOADING_DATA = "LOADING_DATA";
export const LOADING_WHOIS = "LOADING_WHOIS";
export const STOP_LOADING_DATA = "STOP_LOADING_DATA";
export const LOADING_FOLDER_SEARCH = "LOADING_FOLDER_SEARCH";
export const STOP_LOADING_FOLDER_SEARCH = "STOP_LOADING_FOLDER_SEARCH";
export const STOP_LOADING_WHOIS = "STOP_LOADING_WHOIS";
// Data reducer types
// Applications
export const SET_APPLICATIONS = "SET_APPLICATIONS";
export const SET_APPLICATION_SEARCH = "SET_APPLICATION_SEARCH";
export const POST_APPLICATION = "POST_APPLICATION";
export const PUT_APPLICATION = "PUT_APPLICATION";
export const DELETE_APPLICATION = "DELETE_APPLICATION";
// Interviews
export const POST_INTERVIEW_RESPONSE = "POST_INTERVIEW_RESPONSE";
export const SET_INTERVIEW_ANALYSIS = "SET_INTERVIEW_ANALYSIS";
// Profiles
export const SET_PROFILE = "SET_PROFILE";
// Departments
export const SET_DEPARTMENTS = "SET_DEPARTMENTS";
export const POST_DEPARTMENT = "POST_DEPARTMENT";
export const PATCH_DEPARTMENT = "PATCH_DEPARTMENT";
export const DELETE_DEPARTMENT = "DELETE_DEPARTMENT";
// Contacts
export const SET_CONTACTS = "SET_CONTACTS";
export const POST_CONTACT = "POST_CONTACT";
export const PATCH_CONTACT = "PATCH_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const SEARCH_CONTACTS = "SEARCH_CONTACTS";
